import { useCallback, useState } from 'react';

// View preferences (scope, filters, selected tab) that should survive a
// reload on this device, the way the prototype kept them in localStorage.
export function useLocalState<T>(key: string, initial: T): [T, (v: T) => void] {
  const full = `desk.${key}`;
  const [value, setValue] = useState<T>(() => {
    try {
      const raw = localStorage.getItem(full);
      return raw === null ? initial : (JSON.parse(raw) as T);
    } catch {
      return initial;
    }
  });
  const set = useCallback(
    (v: T) => {
      setValue(v);
      try {
        localStorage.setItem(full, JSON.stringify(v));
      } catch {
        // private mode or storage full: keep it for this session only
      }
    },
    [full],
  );
  return [value, set];
}
